import React from "react"
import { makeStyles } from "@mui/styles"

import { START_HOUR, BLOCK_HEIGHT, BLOCK_TIME, TOTAL_BLOCKS, HEADER_BLOCK_HEIGHT } from "../../utils/constant"
import { COLORS } from "../../utils"

export default function TimeLabelsColumn() {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      {Array.from({ length: TOTAL_BLOCKS }).map((_, i) => {
        const totalMinutes = START_HOUR * 60 + i * BLOCK_TIME
        const hours = Math.floor(totalMinutes / 60)
        const minutes = totalMinutes % 60
        const isHour = minutes === 0

        return (
          <div
            key={i}
            className={classes.block}
            style={{ height: i === 0 ? HEADER_BLOCK_HEIGHT : BLOCK_HEIGHT }}
          >
            {isHour && (
              <>
                <div
                  className={classes.label}
                  style={{
                    transform:
                      i === 0
                        ? `translateY(${HEADER_BLOCK_HEIGHT / 2}px)`
                        : "translateY(50%)",
                  }}
                >
                  {`${hours.toString().padStart(2, "0")}:${minutes
                    .toString()
                    .padStart(2, "0")}`}
                </div>
                <div className={classes.line} />
              </>
            )}
          </div>
        )
      })}
    </div>
  )
}

const useStyles = makeStyles(() => ({
  container: {
    width: "33px",
  },
  block: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    position: "relative",
    boxSizing: "border-box",
  },
  label: {
    fontSize: "10px",
    lineHeight: "14px",
    fontWeight: 400,
    color: COLORS.BLACK_500,
    width: "100%",
    textAlign: "right",
  },
  line: {
    marginTop: "auto",
    flex: 1,
    height: 1,
    backgroundColor: COLORS.BLACK_500,
    marginLeft: 8,
  },
}))
